/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useRef, useEffect, useCallback} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'

const TRANSITION_DURATION = 300

const AsideDefault: FC = () => {
  const {config, classes} = useLayout()
  const {aside} = config
  const toggleRef = useRef<HTMLDivElement>(null)
  const asideRef = useRef<HTMLDivElement>(null)

  const handleToggle = useCallback((e: Event) => {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const body = document.body
    const asideEl = asideRef.current
    const isMinimized = body.getAttribute('data-kt-aside-minimize') === 'on'

    // Block hover-expand during transition
    asideEl?.classList.add('animating')

    if (isMinimized) {
      body.removeAttribute('data-kt-aside-minimize')
      toggleRef.current?.classList.remove('active')
    } else {
      body.setAttribute('data-kt-aside-minimize', 'on')
      toggleRef.current?.classList.add('active')
    }

    setTimeout(() => {
      asideEl?.classList.remove('animating')
    }, TRANSITION_DURATION)
  }, [])

  useEffect(() => {
    const el = toggleRef.current
    if (!el) return

    el.addEventListener('click', handleToggle, true)
    return () => el.removeEventListener('click', handleToggle, true)
  }, [handleToggle])

  return (
    <div
      ref={asideRef}
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {aside.theme === 'dark' && (
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className='h-45px logo'
              src={toAbsoluteUrl('/media/logos/eywa-logo-dark.png')}
            />
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className='h-25px logo'
              src={toAbsoluteUrl('/media/logos/eywa-logo.png')}
            />
          </Link>
        )}

        {aside.minimize && (
          <div
            ref={toggleRef}
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
          >
            <KTSVG
              path='/media/icons/duotune/arrows/arr080.svg'
              className='svg-icon-1 rotate-180'
            />
          </div>
        )}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}
    </div>
  )
}

export {AsideDefault}
